<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->

<div class="file-area">
  <div *ngIf="pdfAttachments.length > 0" class="attachment-section">
    <p class="attachment-section-title" i18n="@@files">Files</p>
    <div class="pdf-chip-wrapper">
      <mat-chip-set>
        <mat-chip
          *ngFor="let file of pdfAttachments"
          class="file-attachment-chip noselect"
          (click)="openPdf(file)"
          (keydown.enter)="openPdf(file)"
        >
          <fa-icon [icon]="faFilePdf"></fa-icon>
          <span>{{ file.file_name }}</span>
        </mat-chip>
      </mat-chip-set>
    </div>
  </div>

  <div *ngIf="imageSliderItems.length > 0" class="attachment-section">
    <p class="attachment-section-title" i18n="@@images">Images</p>
    <div class="image-slider-wrapper">
      <epg-image-slider
        class="wrap-mode"
        [images]="imageSliderItems"
        [imageHeightInPx]="110"
        [imageWidthInPx]="150"
        [displayBorder]="true"
      ></epg-image-slider>
    </div>
  </div>
</div>
